// Estados de página compartidos por todos los módulos de la plataforma nueva.
//   <CargandoPagina texto="Cargando alertas…" />
//   <EnMigracion modulo="Plan" />                       marcador de un módulo sin migrar
//   <EstadoVacio icono={Inbox} titulo="…" descripcion="…" accion={<Button …/>} />
//   <EstadoError titulo="…" descripcion={error} onReintentar={recargar} />
// Vacío y error siguen la receta de la skill (05 § Estado vacío): ícono en círculo relief, título corto, una línea
// de qué pasó y UN botón con la salida. Van dentro del panel donde estaría el contenido (no crean su propio glass
// salvo `enTarjeta`).
import { AlertTriangle, RotateCcw } from 'lucide-react';
import { Glass } from '../../ds/components/core/Glass';
import { Button } from '../../ds/components/core/Button';
import { Spinner } from '../../ds/components/core/Spinner';
import { cn } from '../../ds/lib/cn';

export function CargandoPagina({ texto = 'Cargando…' }) {
  return (
    <div role="status" aria-busy="true" className="flex h-full min-h-60 items-center justify-center gap-3 text-body-sm text-ink-2">
      <Spinner size={22} className="text-accent-ink" />
      {texto}
    </div>
  );
}

function Contenedor({ enTarjeta, className, children, ...rest }) {
  const clases = cn('flex flex-col items-center gap-3 px-4 py-12 text-center', className);
  return enTarjeta
    ? <Glass className={clases} {...rest}>{children}</Glass>
    : <div className={clases} {...rest}>{children}</div>;
}

export function EstadoVacio({ icono: Icono, titulo, descripcion, accion, enTarjeta = false, className }) {
  return (
    <Contenedor enTarjeta={enTarjeta} className={className}>
      {Icono && (
        <span className="db-relief grid h-12 w-12 place-items-center rounded-full text-accent-ink">
          <Icono size={22} aria-hidden="true" />
        </span>
      )}
      <p className="font-display text-title-sm font-medium text-ink">{titulo}</p>
      {descripcion && <p className="max-w-md text-body-sm text-ink-2">{descripcion}</p>}
      {accion}
    </Contenedor>
  );
}

export function EstadoError({ titulo = 'No pudimos cargar la información', descripcion, onReintentar, textoReintentar = 'Reintentar', enTarjeta = false, className }) {
  return (
    <Contenedor enTarjeta={enTarjeta} role="alert" className={className}>
      <span className="db-relief grid h-12 w-12 place-items-center rounded-full text-neg">
        <AlertTriangle size={22} aria-hidden="true" />
      </span>
      <p className="font-display text-title-sm font-medium text-ink">{titulo}</p>
      {descripcion && <p className="max-w-md text-body-sm text-ink-2">{descripcion}</p>}
      {onReintentar && <Button variant="secondary" icon={RotateCcw} onClick={onReintentar}>{textoReintentar}</Button>}
    </Contenedor>
  );
}

/** Marcador de un módulo que todavía no se migra (lo reemplaza su página real). */
export function EnMigracion({ modulo }) {
  return (
    <div className="p-4 md:p-6">
      <Glass className="flex flex-col gap-2 py-12 text-center">
        <p className="font-display text-title font-medium text-ink">{modulo}</p>
        <p className="text-body-sm text-ink-2">Este módulo se está migrando a la plataforma nueva.</p>
      </Glass>
    </div>
  );
}
